/**
 * Search Page / Container Component
 * For more informations about this kind of component, read README
 */
// change data to remoteStates
import React, { useEffect } from 'react';
import { useQuery } from 'react-query';

import './styles.css';

import ProducersList from './components/ProducersList';
import FloatingButtons from './components/FloatingButtons';
import ProducersMap from './components/ProducersMap';
import Loading from './components/Loading';

import { OfferService, SpaceService } from '../../../support/services/api';

import useMap from '../../../model/useMap';
import useDistances from '../../../model/useDistances';

export default function Search() {
  const { sharedStates: mapStates, commands: mapCommands } = useMap();
  const { sharedStates: addressesStates, commands: addressesCommands } = useDistances();

  const { data: allProducersGeocoded } = useQuery('allProducersGeocoded', SpaceService().getAllGeocoded);
  const { data: producersOffers } = useQuery(
    ['producerOffers', mapStates.openedProducerId],
    () => OfferService().getByProducerId(mapStates.openedProducerId),
    {
      keepPreviousData: true,
      enabled: !!mapStates.openedProducerId,
    },
  );

  useEffect(() => {
    if (allProducersGeocoded && mapStates.userLocation) {
      addressesCommands.setMaxDistance(50);
      addressesCommands.setReferenceCoords(mapStates.userLocation);
      addressesCommands.setAddresses(
        [].concat(...allProducersGeocoded.producers
          .map((producer) => producer.addresses
            .map((address) => ({ ...address, producer })))),
      );
    }
  }, [allProducersGeocoded, mapStates.userLocation]);

  return (
    <div className="producers-list-container">
      <Loading sharedStates={mapStates}/>
      <FloatingButtons
        commands={mapCommands}
        sharedStates={mapStates}
      />
      <ProducersMap
        commands={mapCommands}
        sharedStates={{
          ...mapStates,
          ...addressesStates,
          producers: allProducersGeocoded?.producers,
          offers: producersOffers?.offers,
        }}
      />
      <ProducersList
        commands={{ ...mapCommands, ...addressesCommands }}
        sharedStates={{
          ...mapStates,
          ...addressesStates,
          producers: allProducersGeocoded?.producers,
        }}
      />
    </div>
  );
}
